import React from "react";

export type MenuIcon =
    | "InboxIcon"
    | "SendIcon"
    | "SpamIcon"
    | "RequestDocumentIcon"
    | "FileIcon"
    | "SettingsIcon"
    | "UnlockIcon"
    | "MessageHistoryIcon"
    | "ReportsIcon"
export interface IconImageProps {
    height?: number;
    width?: number;
    color?: string;
    disabled?: boolean;
}
export interface IMenuIconProps extends IconImageProps {
    icon: MenuIcon;
}

export const SideMenuIcon: React.FC<IMenuIconProps> = props => {
    let menuIcon = <i style={{ width: props.width, height: props.height }} className="side-menu-icon-placeholder" />;
    switch (props.icon) {
        case "InboxIcon":
            menuIcon = <InboxIcon {...props}></InboxIcon>;
            break;
        case "SendIcon":
            menuIcon = <SendIcon {...props}></SendIcon>;
            break;
        case "SpamIcon":
            menuIcon = <SpamIcon {...props}></SpamIcon>;
            break;
        case "ReportsIcon":
            return <RequestDocumentIcon {...props} />;
        case "FileIcon":
            menuIcon = <FileIcon {...props}></FileIcon>;
            break;
        case "UnlockIcon":
            menuIcon = <UnlockIcon {...props}></UnlockIcon>;
            break;
        case "SettingsIcon":
            menuIcon = <SettingsIcon {...props}></SettingsIcon>;
            break;
        case "MessageHistoryIcon":
            menuIcon = <MessageHistoryIcon {...props} />;
            break;

    }
    return menuIcon;
};

export const InboxIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 16}
            height={props.height || 16}
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color}
                d="M0 4a2 2 0 012-2h12a2 2 0 012 2v8a2 2 0 01-2 2H2a2 2 0 01-2-2V4zm2-1a1 1 0 00-1 1v.217l7 4.2 7-4.2V4a1 1 0 00-1-1H2zm13 2.383l-4.708 2.825L15 11.105V5.383zm-.034 6.876l-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 002 13h12a1 1 0 00.966-.741zM1 11.105l4.708-2.897L1 5.383v5.722z"
            ></path>
        </svg>
    );
};

export const SendIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 16}
            height={props.height || 16}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g clipPath="url(#clip0_2203_447620)">
                <path
                    fill={props.color ?? "#fff"}
                    d="M15.854.146a.5.5 0 01.11.54l-5.819 14.547a.75.75 0 01-1.329.124l-3.178-4.995L.643 7.184a.75.75 0 01.124-1.33L15.314.037a.5.5 0 01.54.11V.146zM6.636 10.07l2.761 4.338L14.13 2.576 6.636 10.07zm6.787-8.201L1.591 6.602l4.339 2.76 7.494-7.493h-.001z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_2203_447620">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const SpamIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 16}
            height={props.height || 16}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color ?? "#fff"}
                d="M5.338 1.59a61.43 61.43 0 00-2.837.856.48.48 0 00-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.724 10.724 0 002.287 2.233c.346.244.652.42.893.533.12.057.218.095.293.118.033.011.067.02.101.025a.615.615 0 00.1-.025c.076-.023.174-.061.294-.118.24-.113.547-.29.893-.533.87-.626 1.64-1.379 2.287-2.233 1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 00-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.222-2.662.523zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 011.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.774 11.774 0 01-2.517 2.453c-.33.238-.682.447-1.048.625-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7.154 7.154 0 01-1.048-.625 11.777 11.777 0 01-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 012.185 1.43 62.455 62.455 0 015.072.56z"
            ></path>
            <path
                fill={props.color ?? "#fff"}
                d="M7.001 11a1 1 0 112 0 1 1 0 01-2 0zM7.1 4.995a.905.905 0 111.8 0l-.35 3.507a.553.553 0 01-1.1 0L7.1 4.995z"
            ></path>
        </svg>
    );
};

export const RequestDocumentIcon: React.FC<IconImageProps> = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 16}
            height={props.height || 16}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color || "#fff"}
                d="M8 6.5a.5.5 0 01.5.5v1.5H10a.5.5 0 010 1H8.5V11a.5.5 0 01-1 0V9.5H6a.5.5 0 110-1h1.5V7a.5.5 0 01.5-.5z"
            ></path>
            <path
                fill={props.color || "#fff"}
                d="M14 4.5V14a2 2 0 01-2 2H4a2 2 0 01-2-2V2a2 2 0 012-2h5.5L14 4.5zm-3 0A1.5 1.5 0 019.5 3V1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V4.5h-2z"
            ></path>
        </svg>
    );
};

export const FileIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width || 16}
            height={props.height || 16}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color ?? "#fff"}
                d="M.54 3.87L.5 3a2 2 0 012-2h3.672a2 2 0 011.414.586l.828.828A2 2 0 009.828 3h3.982a2 2 0 011.992 2.181l-.637 7A2 2 0 0113.174 14H2.826a2 2 0 01-1.991-1.819l-.637-7a1.99 1.99 0 01.342-1.31V3.87zM2.19 4a1 1 0 00-.996 1.09l.637 7a1 1 0 00.995.91h10.348a1 1 0 00.995-.91l.637-7A1.001 1.001 0 0013.81 4H2.19zm4.69-1.707A1 1 0 006.172 2H2.5a1 1 0 00-1 .981l.006.139C1.72 3.042 1.95 3 2.19 3h5.396l-.707-.707h.001z"
            ></path>
        </svg>
    );
};
export const SettingsIcon: React.FC<IMenuIconProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 16}
        height={props.height || 16}
        fill="none"
        viewBox="0 0 16 16"
    >
        <g fill={props.color ?? "#fff"} clipPath="url(#clip0_2203_448476)">
            <path d="M8 4.754a3.246 3.246 0 100 6.492 3.246 3.246 0 000-6.492zM5.754 8a2.246 2.246 0 114.492 0 2.246 2.246 0 01-4.492 0z"></path>
            <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 01-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 01-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 01.52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 011.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.874.874 0 011.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 01.52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.874.874 0 01-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 01-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 002.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.872 1.872 0 001.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 00-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.874 1.874 0 00-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 00-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 001.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 003.06 4.377l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 002.692-1.115l.094-.319z"></path>
        </g>
        <defs>
            <clipPath id="clip0_2203_448476">
                <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);


export const LogOutIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 471.2 471.2"
        enableBackground="new 0 0 471.2 471.2"
        xmlSpace="preserve"
        width={props.width}
        height={props.height}
        fill={props.color}
    >
        <path d="M227.619 444.2h-122.9c-33.4 0-60.5-27.2-60.5-60.5V87.5c0-33.4 27.2-60.5 60.5-60.5h124.9c7.5 0 13.5-6 13.5-13.5s-6-13.5-13.5-13.5h-124.9c-48.3 0-87.5 39.3-87.5 87.5v296.2c0 48.3 39.3 87.5 87.5 87.5h122.9c7.5 0 13.5-6 13.5-13.5s-6.1-13.5-13.5-13.5z" />
        <path d="m450.019 226.1-85.8-85.8c-5.3-5.3-13.8-5.3-19.1 0-5.3 5.3-5.3 13.8 0 19.1l62.8 62.8h-273.9c-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5h273.9l-62.8 62.8c-5.3 5.3-5.3 13.8 0 19.1 2.6 2.6 6.1 4 9.5 4s6.9-1.3 9.5-4l85.8-85.8c5.4-5.4 5.4-14 .1-19.2z" />
    </svg>
);

export const UnlockIcon: React.FC<IMenuIconProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 16}
        height={props.height || 16}
        fill="none"
        viewBox="0 0 16 16"
    >
        <g clipPath="url(#clip0_2203_447118)">
            <path
                fill={props.color ?? "#fff"}
                d="M11 1a2 2 0 00-2 2v4a2 2 0 012 2v5a2 2 0 01-2 2H3a2 2 0 01-2-2V9a2 2 0 012-2h5V3a3 3 0 116 0v4a.5.5 0 01-1 0V3a2 2 0 00-2-2zM3 8a1 1 0 00-1 1v5a1 1 0 001 1h6a1 1 0 001-1V9a1 1 0 00-1-1H3z"
            ></path>
        </g>
        <defs>
            <clipPath id="clip0_2203_447118">
                <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export const MessageHistoryIcon: React.FC<IMenuIconProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        height={props.height || 16}
        width={props.width || 16}>
        <path fill={props.color ?? "#fff"} d="M22 12.41V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v18l4-4h3.29A7.001 7.001 0 0 0 23 16c0-1.31-.37-2.54-1-3.59M5.17 16 4 17.17V4h16v6.26A6.963 6.963 0 0 0 16 9c-1.9 0-3.63.77-4.89 2H6v2h3.69c-.44.91-.69 1.93-.69 3H5.17M16 20.85c-2.68 0-4.85-2.17-4.85-4.85s2.17-4.85 4.85-4.85c2.67 0 4.85 2.17 4.85 4.85s-2.18 4.85-4.85 4.85M18 9H6V7h12v2m-1.5 6.82 2.44 1.41-.75 1.3L15 16.69V13h1.5v2.82Z" />
    </svg>
);

export const HelpIcon: React.FC<IconImageProps> = props => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={props.width || 16}
        height={props.height || 16}
        fill="none"
        viewBox="0 0 16 16"
    >
        <g fill={props.color ?? "#fff"} clipPath="url(#clip0_2203_447732)">
            <path d="M8 15A7 7 0 118 1a7 7 0 010 14zm0 1A8 8 0 108-.001 8 8 0 008 16z"></path>
            <path d="M5.255 5.786a.237.237 0 00.241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 00.25.246h.811a.25.25 0 00.25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"></path>
        </g>
        <defs>
            <clipPath id="clip0_2203_447732">
                <path fill="#fff" d="M0 0H16V16H0z"></path>
            </clipPath>
        </defs>
    </svg>
);

export const ReportsIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color}
                d="M5 4a.5.5 0 100 1h6a.5.5 0 000-1H5zm-.5 2.5A.5.5 0 015 6h6a.5.5 0 010 1H5a.5.5 0 01-.5-.5zM5 8a.5.5 0 100 1h6a.5.5 0 000-1H5zm0 2a.5.5 0 000 1h3a.5.5 0 000-1H5z"
            ></path>
            <path
                fill={props.color}
                d="M2 2a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H4a2 2 0 01-2-2V2zm10-1H4a1 1 0 00-1 1v12a1 1 0 001 1h8a1 1 0 001-1V2a1 1 0 00-1-1z"
            ></path>
        </svg>
    );
};

export const SendMessageIcon: React.FC<IconImageProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="43" fill="none" viewBox="0 0 48 43">
            <path
                fill={props.color}
                d="M45.957 29.129v-1.33a7.02 7.02 0 10-14.04 0v1.33a2.659 2.659 0 00-1.957 2.55v9.14A2.183 2.183 0 0032.14 43h13.595a2.182 2.182 0 002.18-2.181v-9.142a2.66 2.66 0 00-1.958-2.548zm-7.015-6.066a4.742 4.742 0 014.733 4.737v.912a33.882 33.882 0 00-4.738-.372c-1.586.013-3.169.136-4.738.366v-.903a4.745 4.745 0 014.743-4.74zm-6.7 17.756v-9.142a.394.394 0 01.317-.39 36.058 36.058 0 016.378-.67c2.142.033 4.277.258 6.38.67.185.038.318.2.316.39v3.07c.006.041.014.083.025.124l.077 5.847-13.494.1zM13.532 17.698l-7.524 7.53a1.14 1.14 0 001.613 1.613l7.532-7.53a1.143 1.143 0 00-1.621-1.613z"
            ></path>
            <path
                fill={props.color}
                d="M43.428 0H4.466a4.412 4.412 0 00-3.65 1.914A4.53 4.53 0 000 4.483v24.224a4.516 4.516 0 001.3 3.168 4.457 4.457 0 003.166 1.315h19.492a1.14 1.14 0 100-2.281H4.466a2.178 2.178 0 01-1.541-.638 2.21 2.21 0 01-.643-1.564V4.483c.003-.452.142-.893.4-1.264a2.156 2.156 0 011.784-.937h38.962a2.238 2.238 0 012.205 2.201v11.301a1.14 1.14 0 102.282 0V4.483A4.52 4.52 0 0043.428 0z"
            ></path>
            <path
                fill={props.color}
                d="M23.945 18.546h.02a4.452 4.452 0 002.565-.81l13.538-9.493a1.14 1.14 0 00-1.31-1.868L25.22 15.87c-.37.258-.81.396-1.262.395a2.17 2.17 0 01-1.254-.395L9.166 6.375a1.14 1.14 0 00-1.31 1.868l13.538 9.493a4.438 4.438 0 002.551.81z"
            ></path>
        </svg>
    );
};

export const CircleIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g clipPath="url(#clip0_1020_248854)">
                <path fill="#C4C6C8" d="M8 15A7 7 0 118 1a7 7 0 010 14zm0 1A8 8 0 108-.001 8 8 0 008 16z"></path>
            </g>
            <defs>
                <clipPath id="clip0_1020_248854">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const CheckedCircleFilledIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            fill="none"
            viewBox="0 0 16 16"
        >
            <g clipPath="url(#clip0_1020_248852)">
                <path
                    fill="#669440"
                    d="M16 8A8 8 0 11-.001 8 8 8 0 0116 8zm-3.97-3.03a.75.75 0 00-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 00-1.06 1.06L6.97 11.03a.75.75 0 001.079-.02l3.992-4.99a.75.75 0 00-.01-1.05h-.001z"
                ></path>
            </g>
            <defs>
                <clipPath id="clip0_1020_248852">
                    <path fill="#fff" d="M0 0H16V16H0z"></path>
                </clipPath>
            </defs>
        </svg>
    );
};

export const RequestDocumentsLadingIcon: React.FC<IconImageProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="44" fill="none" viewBox="0 0 33 44">
            <path
                fill={props.color}
                d="M10.2 12.068h12.598a1.108 1.108 0 000-2.214H10.2a1.108 1.108 0 000 2.214z"
            ></path>
            <path
                fill={props.color}
                d="M28.393 0H6.26a1.108 1.108 0 000 2.214h22.133a2.415 2.415 0 012.389 2.253v34.612a2.258 2.258 0 01-2.253 2.254H17.606V31.53a4.44 4.44 0 00-4.468-4.4H2.214V4.466a1.108 1.108 0 00-2.214 0v22.784c.004.448.08.894.221 1.32h.004c.224.73.639 1.387 1.2 1.905l12.547 11.809a4.45 4.45 0 003.136 1.265h11.425A4.472 4.472 0 0033 39.082V4.392A4.626 4.626 0 0028.394 0zM15.392 40.58L3.45 29.342h9.686a2.25 2.25 0 012.255 2.186v9.05z"
            ></path>
            <path
                fill={props.color}
                d="M10.2 19.49h12.598a1.108 1.108 0 000-2.214H10.2a1.108 1.108 0 000 2.214z"
            ></path>
        </svg>
    );
};

export const ChevronRightIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? 16}
            height={props.height ?? 16}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color ?? "#212529"}
                fillRule="evenodd"
                d="M4.646 1.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 11-.708-.708L10.293 8 4.646 2.354a.5.5 0 010-.708z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};

export const ChevronLeftIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? 16}
            height={props.height ?? 16}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color ?? "#212529"}
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 010 .708L5.707 8l5.647 5.646a.5.5 0 01-.708.708l-6-6a.5.5 0 010-.708l6-6a.5.5 0 01.708 0z"
                clipRule="evenodd"
            ></path>
        </svg>
    );
};


export const InfoCircleIcon: React.FC<IconImageProps> = props => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width ?? "16"}
            height={props.height ?? "16"}
            fill="none"
            viewBox="0 0 16 16"
        >
            <path
                fill={props.color ?? "#0973ba"}
                d="M8 16A8 8 0 108 0a8 8 0 000 16zm.93-9.412L7.93 11.293c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 110-2 1 1 0 010 2z"
            ></path>
        </svg>
    );
};

export const ActionDropDownButtonIcon: React.FC<IconImageProps> = () => (
    <svg width="14" height="4" viewBox="0 0 14 4" fill="#05386B" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 3.5C1.17157 3.5 0.5 2.82843 0.5 2C0.5 1.17157 1.17157 0.5 2 0.5C2.82843 0.5 3.5 1.17157 3.5 2C3.5 2.82843 2.82843 3.5 2 3.5ZM7 3.5C6.17157 3.5 5.5 2.82843 5.5 2C5.5 1.17157 6.17157 0.5 7 0.5C7.82843 0.5 8.5 1.17157 8.5 2C8.5 2.82843 7.82843 3.5 7 3.5ZM12 3.5C11.1716 3.5 10.5 2.82843 10.5 2C10.5 1.17157 11.1716 0.5 12 0.5C12.8284 0.5 13.5 1.17157 13.5 2C13.5 2.82843 12.8284 3.5 12 3.5Z" />
    </svg>
);
